@if (isLoading()) {
  <lib-overlay-loader />
} @else {
  <div class="flex flex-col h-full" [class]="floatingPageClasses()">
    <div [class]="floating() ? 'mb-lg' : 'mb-2xl'">
      <p class="text-2xl text-neutral-900 font-semibold">
        {{ 'admin_list_screen_title' | transloco }}
      </p>
    </div>

    <section
      class="flex flex-col justify-between flex-1"
      [class]="floating() ? 'floating-card p-2xl' : ''"
      data-testid="admins-list-section">
      <div>
        <div
          class="flex justify-between items-center mb-lg"
          [class]="floating() ? '' : 'py-xl border-b border-neutral-200'">
          <div class="flex gap-lg items-center">
            <p class="text-neutral-900 font-semibold text-lg">
              {{ 'admin_list_screen_sub_title' | transloco }}
            </p>

            <lib-badge
              [label]="totalAdminsCount()"
              badgeClass="px-sm border-none text-sm font-medium bg-primary-50 text-primary-700" />
          </div>

          <button
            class="bg-primary-500 text-white font-medium text-sm py-sm px-2xl border-none rounded-md gap-sm flex items-center"
            type="button"
            id="admin_list_add_admin"
            (click)="openAssignAdminUsersDialog()">
            <lib-add-icon [iconClass]="'size-5 text-white'" />

            <span class="hidden md:block">
              {{ 'admin_list_add_admin' | transloco }}
            </span>
          </button>
        </div>

        <div>
          <lib-group-user-card
            [actionList]="actionList"
            [list]="admins()"
            itemType="User"
            (actionListItemClickEmitter)="actionListItemClick($event)"
            [mode]="'view'" />
        </div>
      </div>

      @if (admins().length) {
        <div class="p-sm">
          <lib-paginator
            class="mt-4xl"
            [sizeOptionsLabel]="
              'pagination_number_of_rows_per_page_label' | transloco
            "
            [nextBtnLabel]="'pagination_next_button_label' | transloco"
            [previousBtnLabel]="'pagination_previous_button_label' | transloco"
            [currentPage]="currentPage()"
            [totalPages]="totalPages()"
            [totalItems]="+totalAdminsCount()"
            [pageItemCount]="admins().length"
            [showChangeSize]="true"
            [sizeOptions]="pageSizeOptions"
            (goTo)="handlePagination($event)"
            (next)="handlePagination($event)"
            (previous)="handlePagination($event)"
            [showChangeSize]="false" />
        </div>
      }
    </section>
  </div>
}

<ng-template #removeAdmin>
  <div class="flex justify-center">
    <div
      class="flex justify-center items-center bg-destructive-50 p-lg rounded-full mb-xl">
      <lib-delete-icon [iconClass]="'size-8 text-destructive-500'" />
    </div>
  </div>

  <p class="text-lg text-center font-medium mb-sm text-neutral-900">
    {{ 'admin_list_remove_popup_remove_admin_title' | transloco }}
  </p>

  <p class="text-sm text-neutral-500 text-center mb-4xl">
    {{ 'admin_list_remove_popup_remove_admin_warning' | transloco }}
  </p>

  <div class="flex flex-col gap-md text-base font-medium">
    <button
      (click)="onRemoveAdmin()"
      [class.opacity-30]="isRemoveAdminLoading()"
      [disabled]="isRemoveAdminLoading()"
      class="bg-destructive-500 py-sm rounded-md text-white text-base cursor-pointer">
      {{ 'admin_list_remove_popup_yes_remove_it_button' | transloco }}
    </button>

    <button
      (click)="closeModal()"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
      {{ 'admin_list_remove_popup_no_keep_it_button' | transloco }}
    </button>
  </div>
</ng-template>

<ng-template #assignAdminUsersDialog>
  <lib-assign-group-users
    [groupUsersCards]="adminUsersCards()"
    [selectedGroupUsersCards]="selectedUsers()"
    (unselectGroupUser)="removeSelectedAdminUser($event)"
    (selectGroupUser)="onSelectAdminUser($event)"
    (filterGroupUsersCards)="getUsers($event)"
    (paginateGroupUsersCards)="getUsers('', $event)"
    (saveAssignedGroupUsers)="changeAdminRole()"
    [isLoading]="isLoadingGroupUsers()"
    [currentPage]="modalCurrentPage()"
    [totalPages]="modalTotalPages()"
    [itemType]="'User'"
    [assignItemsModalTitle]="'add_admins_modal_label' | transloco"
    [isSubmitLoading]="isChangeAdminRoleLoading()"
    (cancelModal)="clearSelectedUsers()" />
</ng-template>
